/**
 * Swiper React 7.4.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2021 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: December 24, 2021
 */

import { Swiper } from './swiper.js';
import { SwiperSlide } from './swiper-slide.js';
export { Swiper, SwiperSlide };